export { SERVICE_PROVIDERS } from 'globalconfig/tenants/global';
